import { LastOperationResultDto } from "./lastOperationResultDto";

export class DataForEnrolmentCancellationDto {    

    behaviourPatternCancelationCode!: number;

    lastOperationResult: LastOperationResultDto = new LastOperationResultDto();

}